import { createGlobalStyle } from "styled-components";

const Colors = createGlobalStyle`
    :root {
  --primary-color: #34CB79;
  --title-color: #322153;
  --text-color: #6C6C80;
}

`;

export default Colors;
